import { Plus } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconPlus(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <Plus />
    </IconWrapper>
  );
}
